<template>
  <div
    v-if="isVisible"
    class="modal-backdrop fade show"
  ></div>

  <div
    class="modal fade"
    :class="{ show: isVisible }"
    :style="{ display: isVisible ? 'block' : 'none' }"
    tabindex="-1"
    :aria-hidden="!isVisible"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-info-subtle">
          <h5 class="modal-title">
            <span class="material-icons me-2" style="vertical-align: middle;">info</span>
            {{ $t('plan_trail.route_length_warning_modal.tip_split_into_multiple_routes') }}
          </h5>
        </div>
        <div class="modal-body">
          <i18n-t keypath="plan_trail.route_length_warning_modal.your_route_is_over_30_km" tag="p" scope="global">
            <template #split><strong>{{ $t('plan_trail.route_length_warning_modal.split_route') }}</strong></template>
          </i18n-t>
          <p class="text-muted mb-0">
            {{ $t('plan_trail.route_length_warning_modal.multi_day_hikes_with_shorter_individual') }}
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link text-muted" @click="dontShowAgain">{{ $t('plan_trail.route_length_warning_modal.don_t_show_again') }}</button>
          <button type="button" class="btn btn-primary" @click="dismiss">{{ $t('plan_trail.route_length_warning_modal.got_it') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { dismissRouteLengthWarningPermanently } from '../services/routeLengthWarningPreference';

export default defineComponent({
  setup() {
    const isVisible = ref(false);

    function show() {
      isVisible.value = true;
    }

    function dismiss() {
      isVisible.value = false;
    }

    // Permanent, per-device opt-out: never show the warning again on this device.
    function dontShowAgain() {
      dismissRouteLengthWarningPermanently();
      isVisible.value = false;
    }

    return {
      isVisible,
      show,
      dismiss,
      dontShowAgain
    };
  }
});
</script>

<style scoped>
.bg-info-subtle {
  background-color: #fddf00 !important;

  h5, .modal-title, .material-icons {
    color: #212529 !important;
  }
}

.modal-header .material-icons {
  font-size: 24px;
}
</style>
